
// good if you get an encoded string from the server using the liquid filter and need to reverse it in a the react context.
// some cases the "'" will break JSON.parse() EXAMPLE: "<p>MY Mix's Rewards</p>" needs to be escaped.
/**
 * unescapeHtml
 * @param {*} html 
 * @returns {string | null}
 */
export const unescapeHtml = (html) => {
  let doc = new DOMParser().parseFromString(html, 'text/html');
  return doc.documentElement.textContent;
}
